// -----------------------------  COMMON -----------------------------
export { AnimatePresence, Button, motion, PAGE_ANIMATION_OPTIONS, useRouter} from '@/imports-files/common/common';
// -----------------------------  COMMON  -----------------------------


// -----------------------------  CUSTOM COMPONENTS -----------------------------
export {default as MainArea} from '@/components/main-area';
export {default as Modal} from '@/components/modal';
// -----------------------------  CUSTOM COMPONENTS -----------------------------


// -----------------------------  STYLESHEET -----------------------------
export {default as Classes } from '@/styles/components/congrats/_index.module.scss';
export {default as Styles } from '@/styles/components/button/_index.module.scss';
// -----------------------------  STYLESHEET -----------------------------
